import Vue from "vue";
import messages from "../static/mocks/i18n";

export default {
    install() {
        Vue.mixin({
            computed: {
                $locale() {
                    return this.$t("trad");
                },
                $trad() {
                    return messages[this.$t("trad")];
                }
            },
            methods: {
                $tradFor(obj) {
                    const trad = obj[this.$locale];
                    return (trad && trad.value) || (obj["en"] && obj["en"].value);
                }
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/trads.js